import React from 'react';
import PropTypes from 'prop-types';
import RemoteDataProvider from './RemoteDataProvider';
import { withRouter } from 'containers/withRouter';

const BankingTransactionProposalsContext = React.createContext();

function providesBankingTransactionProposals(Component) {
  class RemoteBankingTransactionProposals extends React.Component {
    render() {
      const accountingDocumentId = parseInt(this.props.match.params.documentId, 10);
      const baseURL = `/accounting-documents/${accountingDocumentId}/banking-transaction-proposals`;

      return (
        <RemoteDataProvider
          baseURL={baseURL}
          isCollection
          autoFetch={!isNaN(accountingDocumentId)}
          render={(remoteData) => {
            return (
              <BankingTransactionProposalsContext.Provider value={remoteData}>
                <Component {...this.props} />
              </BankingTransactionProposalsContext.Provider>
            );
          }}
        />
      );
    }
  }

  RemoteBankingTransactionProposals.propTypes = {
    match: PropTypes.object.isRequired,
  };

  return withRouter(RemoteBankingTransactionProposals);
}

function consumesBankingTransactionProposals(Component, provideValueAs = 'bankingTransactionProposals') {
  return function ComponentThatConsumesBankingTransactionProposals(props) {
    return (
      <BankingTransactionProposalsContext.Consumer>
        {(remoteData) => {
          const consumedProps = {
            remoteBankingTransactionProposals: remoteData,
            [provideValueAs]: remoteData.value,
            bankingTransactionProposalIds: new Set(remoteData.value.map(({ id }) => id)),
            bankingTransactionProposalScores: new Map(remoteData.value.map(({ id, score }) => [id, score])),
          };

          return <Component {...props} {...consumedProps} />;
        }}
      </BankingTransactionProposalsContext.Consumer>
    );
  };
}

export { providesBankingTransactionProposals, consumesBankingTransactionProposals };
